import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import * as Sentry from "@sentry/angular";

@Injectable()
export class Sentry400Interceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((httpErrorResponse: HttpErrorResponse) => {
        if (httpErrorResponse.status === 400) {
          Sentry.addBreadcrumb({
            type: "http",
            level: "fatal",
            category: "http.bad_request",
            timestamp: new Date().getTime() / 1000,
            data: {
              url: httpErrorResponse.url,
              method: "POST",
              status_code: 400,
              payload: JSON.stringify(httpErrorResponse.error)
            }
          });
        }

        return throwError(() => httpErrorResponse);
      })
    );
  }
}
